import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { isExternalDomain, isFileDownloadUrl } from 'utils'
import { useRouter } from 'next/router'
import useTransRoute from '@hooks/useTransRoute'

interface Props {
  href?: string
  external?: boolean
  newPage?: boolean
  prefetch?: boolean
  title?: string
  download?: boolean
  focusable?: boolean
  ariaLabel?: string
  role?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  onFocus?: (event: React.FocusEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  handleTracking?: (ty?: string, c?: string, t?: string, cta?: string) => void
  locale?: string | false
  next?: boolean
  className?: string
  children?: any
  editMode?: boolean
}

const WLink = (props: Props) => {
  const {
    href = null,
    title = undefined,
    download = undefined,
    focusable = true,
    ariaLabel = undefined,
    role = undefined,
    newPage = false,
    prefetch = true,
    onClick = undefined,
    onFocus = undefined,
    locale = false,
    next = false,
    className = '',
    children = null,
    editMode = false,
  } = props

  const router = useRouter()

  const isFileDownload = isFileDownloadUrl(href)
  const isExternal = isExternalDomain(href)
  const tRoute = useTransRoute()
  const contattiNewsletterUrls = [tRoute('/contatti')?.href, tRoute('/newsletter')?.href]
  const [finalUrl, setFinalUrl] = useState('')

  const getUrl = (url: string, contattiNewsletterUrls: string[]): string => {
    if (typeof window === 'undefined') return url

    const isContained = contattiNewsletterUrls.some(contattiUrl => contattiUrl?.includes(url))

    if (isContained) {
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}referral=${window.location.origin}${window.location.pathname}`
    }

    return url
  }

  useEffect(() => {
    if (href) {
      const url = getUrl(href || '/', contattiNewsletterUrls)
      setFinalUrl(url)
    }
  }, [contattiNewsletterUrls, href])

  return isFileDownload || isExternal || !next || editMode ? (
    <a
      href={!editMode ? finalUrl : undefined}
      className={className}
      target={newPage ? '_blank' : undefined}
      rel={newPage || isExternal ? 'noopener noreferrer' : undefined}
      onClick={onClick}
      onFocus={onFocus}
      title={title}
      download={download || undefined}
      aria-label={ariaLabel}
      role={role}
      tabIndex={focusable ? undefined : -1}
    >
      {children}
    </a>
  ) : (
    <Link
      href={finalUrl}
      className={className}
      target={newPage ? '_blank' : undefined}
      rel={newPage ? 'noopener noreferrer' : undefined}
      onClick={onClick}
      onFocus={onFocus}
      title={title}
      download={download || undefined}
      aria-label={ariaLabel}
      role={role}
      tabIndex={focusable ? undefined : -1}
      locale={locale || router.locale}
      {...(!prefetch || router.isPreview ? { prefetch: false } : {})}
    >
      {children}
    </Link>
  )
}

export default WLink
